import { render, staticRenderFns } from "./BtnSelectItem.vue?vue&type=template&id=13eb58e0&scoped=true"
import script from "./BtnSelectItem.vue?vue&type=script&lang=js"
export * from "./BtnSelectItem.vue?vue&type=script&lang=js"
import style0 from "./BtnSelectItem.vue?vue&type=style&index=0&id=13eb58e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13eb58e0",
  null
  
)

export default component.exports